const initialEducationType = {
  educationTypePermissions: {},
  educationTypeLists: [],
  educationTypeStatus: [],
  changedEducationTypeStatus: [],
  loadingEducationType: false,
  errorsEducationType: {},
};

const educationTypeReducer = (educationType = initialEducationType, action) => {
  switch (action.type) {
    case "GET_EDUCATIONTYPELIST_PENDING":
    case "ADD_EDUCATION_TYPE_PENDING":
    case "UPDATE_EDUCATION_TYPE_PENDING":
    case "UPDATE_EDUCATION_TYPE_STATUS_PENDING":
    case "DELETE_EDUCATION_TYPE_PENDING":
    case "GET_EDUCATIONTYPELISTBYID_PENDING":
      return { ...educationType, loadingEducationType: true };

    case "GET_EDUCATIONTYPELIST_FULFILLED":
      return {
        ...educationType,
        loadingEducationType: false,
        educationTypeLists: action.payload,
        educationTypeCount: action.count,
        educationTypePermissions: action.permissions,
      };

    case "ADD_EDUCATION_TYPE_FULFILLED":
    case "UPDATE_EDUCATION_TYPE_FULFILLED":
    case "UPDATE_EDUCATION_TYPE_STATUS_FULFILLED":
    case "DELETE_EDUCATION_TYPE_FULFILLED":
      return {
        ...educationType,
        loadingEducationType: false,
        changedEducationTypeStatus: action.payload,
      };

    case "GET_EDUCATIONTYPELISTBYID_FULFILLED":
      return {
        ...educationType,
        loadingEducationType: false,
        educationTypeLists: action.payload,
      };

    case "RESET_DELETE_EDUCATION_TYPE_STATUS":
      return {
        ...educationType,
        loadingEducationType: false,
        educationTypeStatus: {},
        changedEducationTypeStatus: [],
        errorsEducationType: {},
      };

    case "GET_EDUCATIONTYPELIST_REJECTED":
    case "ADD_EDUCATION_TYPE_REJECTED":
    case "UPDATE_EDUCATION_TYPE_REJECTED":
    case "UPDATE_EDUCATION_TYPE_STATUS_REJECTED":
    case "DELETE_EDUCATION_TYPE_REJECTED":
    case "GET_EDUCATIONTYPELISTBYID_REJECTED":
      return {
        ...educationType,
        loadingEducationType: false,
        errorsEducationType: action.payload,
      };

    default:
      return educationType;
  }
};

export default educationTypeReducer;
